<template>
  <div class="descriptionOfGoods">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.factoryReport.Production_Capability') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Product_Catalogue') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.freportProductcatalogue"
          :otherData="{
            mediaName: '产品目录',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportProductcatalogue',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Main_Product') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.freportMainproduct"
          :otherData="{
            mediaName: '主营产品',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportMainproduct',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Product_Quality_Certificate') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.freportQualitycertificate"
          :otherData="{
            mediaName: '产品认证证书',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportQualitycertificate',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Products_Awards') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.freportProductsawards"
          :otherData="{
            mediaName: '产品荣誉证书',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportProductsawards',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.factoryReport.Brochure') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.freportBrochure"
          :otherData="{
            mediaName: '产品宣传册',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'freportBrochure',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      visible: false,
      id: this.$route.query.id,
    };
  },
  components: {
    showImg,
  },
  computed: {
    factoryDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.factoryDetails),
        );
      },
    },
    descriptionOfGoods: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.factoryImgList.descriptionOfGoods,
          ),
        );
      },
    },
  },
  created() {},
  methods: {
    saveImg() {
      let fileList = [];
      let fileList1 = [];
      let fileList2 = [];
      let fileList3 = [];
      let fileList4 = [];
      this.descriptionOfGoods.freportProductcatalogue.forEach(item => {
        fileList.push(item.id);
      });
      this.descriptionOfGoods.freportMainproduct.forEach(item => {
        fileList1.push(item.id);
      });
      this.descriptionOfGoods.freportQualitycertificate.forEach(item => {
        fileList2.push(item.id);
      });
      this.descriptionOfGoods.freportProductsawards.forEach(item => {
        fileList3.push(item.id);
      });
      this.descriptionOfGoods.freportBrochure.forEach(item => {
        fileList4.push(item.id);
      });
      var postData = {
        freportId: this.factoryDetails.freportId,
        freportMedianame: '产品信息',
        freportMediatype: '1',
        modelType: '2',

        freportProductcatalogue: fileList.join(','),
        freportMainproduct: fileList1.join(','),
        freportQualitycertificate: fileList2.join(','),
        freportProductsawards: fileList3.join(','),
        freportBrochure: fileList4.join(','),
      };
      this.$http
        .post('/hzwmj/factory-media/saveOrUpdateFactoryMedia', postData)
        .then(data => {
          if (data) {
            // this.visible = false;
            this.$message.success('保存成功');
            this.$store.dispatch(
              'report/getfactoryImg',
              this.factoryDetails.freportId,
            );
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.descriptionOfGoods {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          // border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
